module.exports = __webpack_public_path__ + "img/riekkola_sauna.d0bf46c8.jpg";